import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { TechintelDto } from '../dto';
import { TechintelApiService } from './api';

@Injectable({
    providedIn: 'root'
})
export class TechIntelService {
    dataObservable = new BehaviorSubject<TechintelDto>(null);
    onDataReceived = this.dataObservable.asObservable();

    constructor(private readonly techintelApiService: TechintelApiService) { }

    getExportTechIntelSavedSettingsHttp(): Observable<TechintelDto> {
        return this.techintelApiService.getExportTechIntelSavedSettingsHttp();
    }

    setExportTechIntelSavedSettings(payload: TechintelDto): Observable<any> {
        return this.techintelApiService.setExportTechIntelSavedSettings(payload);
    }

    getTechIntelSavedSettings(): Observable<any> {
        return this.techintelApiService.getTechIntelSavedSettings();
    }

    getTechIntelSavedSettingsHttp(): Observable<any> {
        return this.techintelApiService.getTechIntelSavedSettingsHttp();
    }

    setTechIntelSavedSettings(payload: TechintelDto): Observable<any> {
        return this.techintelApiService.setTechIntelSavedSettings(payload);
    }
}
